"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _mobx = require("mobx");
var _state = require("@seedlang/state");
var _lodash = require("lodash");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var VocabTriadWrapper = function VocabTriadWrapper(Component) {
  var _class, _class2, _descriptor, _descriptor2;
  return (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    function _class2(props) {
      var _this;
      _classCallCheck(this, _class2);
      _this = _callSuper(this, _class2, [props]);
      _initializerDefineProperty(_this, "sentenceIndex", _descriptor, _this);
      _initializerDefineProperty(_this, "autoPlay", _descriptor2, _this);
      _this.getSentences = function () {
        var _this$props$word, _AppUI$sentenceStore$;
        var currentWordId = (_this$props$word = _this.props.word) === null || _this$props$word === void 0 ? void 0 : _this$props$word.id;
        if (!currentWordId) return;
        var isMatch = _state.AppUI.sentenceStore.hasIndexData && ((_AppUI$sentenceStore$ = _state.AppUI.sentenceStore.ids) === null || _AppUI$sentenceStore$ === void 0 ? void 0 : _AppUI$sentenceStore$.vocab_triad_id) === currentWordId;
        if (isMatch) return;
        _state.AppUI.sentenceStore.clearIndexData();
        _state.AppUI.sentenceStore.getIndex({
          ids: {
            vocab_triad_id: currentWordId
          },
          queryStrings: {
            vocab_trainer: true,
            vocab_triad_id: currentWordId
          }
        });
      };
      _this.onNextSentence = function () {
        _this.autoPlay = true;
        _this.sentenceIndex = (_this.sentenceIndex + 1) % 3;
      };
      _this.onPreviousSentence = function () {
        _this.autoPlay = true;
        _this.sentenceIndex = _this.sentenceIndex === 0 ? 2 : _this.sentenceIndex - 1;
      };
      _this.getSentences();
      return _this;
    }
    _inherits(_class2, _React$Component);
    return _createClass(_class2, [{
      key: "currentSentence",
      get: function get() {
        if (_state.AppUI.sentenceStore.hasIndexData && (0, _lodash.every)(_state.AppUI.sentenceStore.indexData.map(function (item) {
          var _item$target;
          return (_item$target = item.target) === null || _item$target === void 0 ? void 0 : _item$target.hasVideoClip;
        }))) {
          return _state.AppUI.sentenceStore.indexData[this.sentenceIndex];
        }
        return null;
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        var _prevProps$word, _this$props$word2;
        if (prevProps.conceptId !== this.props.conceptId || ((_prevProps$word = prevProps.word) === null || _prevProps$word === void 0 ? void 0 : _prevProps$word.id) !== ((_this$props$word2 = this.props.word) === null || _this$props$word2 === void 0 ? void 0 : _this$props$word2.id)) {
          this.getSentences();
        }
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          sentences: _state.AppUI.sentenceStore.indexData,
          currentSentence: this.currentSentence,
          onNextSentence: this.onNextSentence,
          onPreviousSentence: this.onPreviousSentence,
          sentenceIndex: this.sentenceIndex,
          autoPlay: this.autoPlay
        }));
      }
    }]);
  }(_react["default"].Component), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "sentenceIndex", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return 0;
    }
  }), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "autoPlay", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _applyDecoratedDescriptor(_class2.prototype, "currentSentence", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "currentSentence"), _class2.prototype), _class2)) || _class;
};
VocabTriadWrapper.displayName = 'VocabTriadWrapper';
var _default = exports["default"] = VocabTriadWrapper;